import { useSelector } from 'react-redux';
import { selectSignIn, selectUserType } from '../../../redux/auth/selectors';
import { Navigate } from 'react-router-dom';

const RestrictedRoute = ({ component: Component }) => {
  const hasAccess = useSelector(selectSignIn);
  const userType = useSelector(selectUserType);
  let redirect = '/';
  if (userType === 'freeUser') redirect = '/free-user/profile';
  if (userType === 'paidUser') redirect = '/man-user/updates';
  if (userType === 'agencyUser') redirect = '/agency-user/updates';
  return !hasAccess ? Component : <Navigate to={redirect} />;
};

export default RestrictedRoute;
